import * as z from 'zod/v4';

import { drawNumberSchema } from '../draw/entry.js';
import { dateTimeSchema } from '../frameworks/entry.js';
import { currencySchema } from '../lib/entry.js';
import { couponProductSchema } from '../product/entry.js';
import { systemTypeEnum } from '../system/entry.js';
import { wagerIdSchema } from './wagerId.js';
import { wagerPropertiesSchema } from './wagerProperties.js';
import { wagerRefundsSchema } from './wagerRefunds.js';
import { wagerStatusSchema } from './wagerStatus.js';

export const wagerListItem = z
  .object({
    betAmount: currencySchema,
    cancelCloseTime: dateTimeSchema.nullish(),
    completedOn: dateTimeSchema.nullish(),
    currentDrawNumber: drawNumberSchema,
    examined: z.boolean(),
    extraDescription: z.string().nullish(),
    isLive: wagerStatusSchema,
    isUserBoards: z.boolean(),
    matchStartTime: dateTimeSchema.nullish(),
    pagingSortKey: z.string(),
    productId: couponProductSchema,
    properties: wagerPropertiesSchema,
    refunds: z.array(wagerRefundsSchema),
    rowCount: z.number(),
    systemType: systemTypeEnum,
    wagerId: wagerIdSchema,
    winAmount: currencySchema,
  })
  .transform(({ isLive: status, ...wagerItem }) => {
    return {
      status,
      ...wagerItem,
    };
  });

export type WagerListItem = z.infer<typeof wagerListItem>;
